<app-relatorio-container
    tituloRelatorio="Ficha Cadastral"
    descricaoRelatorio="Ficha de dados cadastrais completa do prestador."
    categoriaRelatorio="Cadastro"
    [filtrosTemplate]="filtrosTemplate"
    [pdfBlob]="(job$ | async)?.pdfBlob"
    [pdfFileName]="(job$ | async)?.fileName ?? 'ficha-cadastral-pj.pdf'"
    [statusPreview]="(job$ | async)?.status ?? null"
    [progressoPreview]="(job$ | async)?.progress ?? 0"
>
    <ng-template #filtrosTemplate>
        <div class="flex flex-col gap-6">
            <p class="text-sm text-color-secondary m-0">A ficha é emitida com os dados cadastrais completos do prestador selecionado.</p>

            <div class="flex items-center gap-2">
                <p-checkbox inputId="incluirCorpoClinico" [(ngModel)]="incluirCorpoClinico" [binary]="true"></p-checkbox>
                <label for="incluirCorpoClinico" class="text-sm">Incluir relação do corpo clínico</label>
            </div>

            <div class="field pt-5 flex justify-end gap-2">
                <p-button label="Limpar" icon="pi pi-eraser" [variant]="'text'" (click)="limparFormulario()"></p-button>
                <p-button label="Gerar Ficha" icon="pi pi-file-pdf" [appCan]="roleGerar" (click)="gerarRelatorio()" [loading]="isPending" [disabled]="isPending"></p-button>
            </div>
        </div>
    </ng-template>
</app-relatorio-container>
